import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PackageTypeLookupModel } from 'app/generated/backend/trade/api/package-type-lookup-model';

@Injectable()
export class PackageTypeLookupHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
	): Observable<JsonResourceResponse<PackageTypeLookupModel[]>> {
		return this.http.get<JsonResourceResponse<PackageTypeLookupModel[]>>('api/v1/trade/packageTypes/lookup').pipe(
			map(response => response),
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		PackageTypeLookupHandlerService
	]
})
export class PackageTypeLookupHandlerModule { }
